import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IAppState, IApplicationState, INetworkEmailDefaultContentResponse, INetworkEmailLookupDataResponse, ISendEmailRequest, NetworkEmailActionCreators } from '@nkr/store/index';
import { IAdpRecipientFromChain, IBaseResponse, ICluster, IListItem, INetworkEmailSender, IPositionCoordinator, ISignature, IContact } from '@nkr/models/index';
import { ISelectedCenter, ISelectedLogisticsProvider, ISelectedCenterContactPosition, CenterToggle, IValidation, ICalendarInvite, Tab } from './models';
import { Alert, Button, Glyphicon, NavItem } from 'react-bootstrap';
import Centers from './centers';
import Positions from './positions';
import LogisticsProviders from './logistics-providers';
import Attachments from './attachments';
import CalendarInvite from './calendar-invite';
import Message from './message';
import { NavWrapper } from './styles';
import Validation from './validation';
import { toast } from 'react-toastify';
import { Utility } from '@nkr/services/utility';
import TestRecipientsModal from './test-recipients-modal';



interface IOwnProps {
    actionType: number,
    mode?: string;
    id?: string;
    deadline?: string;
    dateTime?: string;
    forceTargetSurgeyDates?: boolean;
    matchOfferType?: number;
    positions?: string;
    extra?: string;
    sourceMatchOffer?: boolean;
    useStreamlinedCancellation?: number;
    realTimeSwapFailure?: number;
    preselectReversal?: number;
    prereversalResponsibles?: string;
    sendMatchOfferWithComments?: (actionType: number, matchOfferType: number, dateTime: string, forceTargetSurgeyDates: boolean, request: ISendEmailRequest, testRecipientList: string[]) => void,
    onCloseSidePanel?: (actionType: number) => void
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLookupData: () => Promise<INetworkEmailLookupDataResponse>,
    getDefaultContent: (mode: string, id: string, positions: string, clcPositions: string, date: string, deadline: string, force: string, type: string, realtimeSwapFailure: number, vendor?: string) => Promise<INetworkEmailDefaultContentResponse>,
    sendEmails: (request: ISendEmailRequest) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    currentTab: number,
    id: string,
    mode: string,
    sender: string,
    subject: string,
    message: string,
    additionalRecipients: string[],
    selectedRecipients: string[],
    swapNumber: string,
    swaps: ICluster[],
    adpRecipientsFromChain: IAdpRecipientFromChain[],
    coordinators: IPositionCoordinator[],
    swapManager: IContact,
    positions: number[],
    clcPositions: number[],
    extra: string[],
    notes: string[],
    deadlineDateTime: string,
    deadlineDate: string,
    deadlineTime: string,
    dateTime: string,
    canDoVirtual: boolean,
    hasClc: boolean,
    force: string,
    useStreamlinedCancellation: number,
    realtimeSwapFailure: number,
    preselectReversal: number,
    prereversalResponsibles: any[],
    type: string,
    centerList: ISelectedCenter[]
    logisticsProviderList: ISelectedLogisticsProvider[],
    emailFlagList: IListItem[],
    receiveEmailOption: number,
    centerContactPositionList: ISelectedCenterContactPosition[],
    emailSenders: INetworkEmailSender[],
    staffList: IContact[],
    files: File[],
    calendarInvite: ICalendarInvite,
    signature: ISignature,
    validation: IValidation,
    isValid: boolean,
    dirty: boolean,
    sentStatus: number,
    disableSend: boolean,
    currentUserEmail: string,
    showTestRecipients: boolean
}

class EmailContainer extends React.Component<TProps, IState> {
    readonly state: IState = {
        currentTab: Tab.Message,
        id: '',
        mode: '',
        sender: 'memberservices@kidneyregistry.org',
        subject: '',
        message: '',
        additionalRecipients: [],
        selectedRecipients: [],
        swapNumber: '',
        swaps: [],
        adpRecipientsFromChain: [],
        coordinators: [],
        swapManager: null,
        positions: [],
        clcPositions: [],
        extra: [],
        notes: [],
        deadlineDateTime: '',
        deadlineDate: '',
        deadlineTime: '',
        dateTime: '',
        canDoVirtual: false,
        hasClc: false,
        force: '',
        useStreamlinedCancellation: 0,
        realtimeSwapFailure: 0,
        preselectReversal: 0,
        prereversalResponsibles: [],
        type: '',
        centerList: [],
        logisticsProviderList: [],
        emailFlagList: [],
        receiveEmailOption: 0,
        centerContactPositionList: [],
        emailSenders: [],
        staffList: [],
        files: [],
        calendarInvite: {
            iCal: false,
            startDate: '',
            startTime: '',
            endDate: '',
            endTime: '',
            requireRsvp: false
        },
        signature: null,
        validation: {
            subject: true,
            message: true,
            centers: true,
            positions: true,
            receiveEmailOption: true,
            calendarInvite: true
        },
        isValid: true,
        dirty: false,
        sentStatus: 0,
        disableSend: false,
        currentUserEmail: '',
        showTestRecipients: false
    }

    componentDidMount = () => {
        this.getData();
    }

    componentDidUpdate(prevProps: TProps) {
        if (prevProps.id !== this.props.id) {
            this.setState(this.getInitialState(), () => {
                this.getData();
            });
        }
    }

    getData = () => {
        let p = qs.parse(location.search);

        let requestedClcPositions = p.clcPositions ?? '';
        let date = p.date ?? '';
        let force = p.force ?? '';
        let type = p.type ?? '';
        let mode = this.props.mode ?? p.mode ?? '';
        let id = this.props.id ?? p.id ?? '';
        let requestedPositions = this.props.positions ?? p.positions ?? '';
        let deadline = this.props.deadline ?? p.deadline ?? '';

        let vendor = p.vendor ?? '';

        let useStreamlinedCancellation = this.props.useStreamlinedCancellation ?? parseInt(p.useStreamlinedCancellation ?? '0');
        let realtimeSwapFailure = this.props.realTimeSwapFailure ?? parseInt(p.realTimeSwapFailure ?? '0');
        let preselectReversal = this.props.preselectReversal ?? p.preselectReversal ?? 0;


        let prereversalResponsibles: any[] = [];

        prereversalResponsibles =
            this.props.prereversalResponsibles != null ? JSON.parse(decodeURIComponent(this.props.prereversalResponsibles))

                : p.prereversalResponsibles
                    ? JSON.parse(p.prereversalResponsibles as string)
                    : [];


        let matchOfferLoadingMessage = mode == 'cancelSwap' ? 'Generating Cancel Swap email template, one moment please...' :
            mode == 'startOffer' ? 'Generating Match Offer email template, one moment please...' :
                'Generating Match Offer email template, one moment please...';


        this.props.showLoading(matchOfferLoadingMessage).then(() => {
            Promise.all([
                this.props.getLookupData(),
                this.props.getDefaultContent(mode, id, requestedPositions, requestedClcPositions, date, deadline, force, type, realtimeSwapFailure, vendor)
            ])
                .then(([lookupDataResponse, defaultContentResponse]) => {
                    let { centerList, logisticsProviderList, emailFlagList, centerContactPositionList, emailSenders, staffList } = lookupDataResponse.data.results;

                    let { from: sender, subject, receiveEmailOption, additionalRecipients, swapNumber, swaps, adpRecipientsFromChain, coordinators, swapManager,
                        positions, clcPositions, extra, notes, deadlineDateTime, deadlineDate, deadlineTime, dateTime, canDoVirtual, selectedCenters, signature, currentUserEmail } = defaultContentResponse.data.results;

                    let calendarInvite = {
                        iCal: false,
                        startDate: '',
                        startTime: '',
                        endDate: '',
                        endTime: '',
                        requireRsvp: false
                    };

                    if (mode == 'logisticsCall' || mode == 'kickOff') {
                        calendarInvite.iCal = true;
                        calendarInvite.startDate = moment(dateTime, 'MM/DD/YYYY HH:mm', true).format('MM/DD/YYYY');
                        calendarInvite.startTime = moment(dateTime, 'MM/DD/YYYY HH:mm', true).format('HH:mm');
                        calendarInvite.endDate = moment(dateTime, 'MM/DD/YYYY HH:mm', true).add(15, 'minutes').format('MM/DD/YYYY');
                        calendarInvite.endTime = moment(dateTime, 'MM/DD/YYYY HH:mm', true).add(15, 'minutes').format('HH:mm');
                    }

                    let firstCluster = swaps.length > 0 ? swaps[0] : null;
                    let courier = firstCluster != null ? firstCluster.courierVendor : 0;

                    let logisticsModes = ['byCluster', 'cancelSwap', 'logistics', 'logisticsCall', 'kickOff', 'joinLogisticsCall', 'joinKickOff', 'commenceSwap'];

                    let selectedLogisticsProviderList = logisticsProviderList.map(lp => {
                        let selected = logisticsModes.indexOf(mode) >= 0 ? lp.id == courier : false;
                        return { ...lp, selected }
                    });

                    this.setState({
                        id,
                        mode,
                        sender,
                        subject,
                        additionalRecipients,
                        selectedRecipients: [...additionalRecipients],
                        swapNumber,
                        receiveEmailOption,
                        swaps,
                        adpRecipientsFromChain,
                        coordinators,
                        swapManager,
                        positions,
                        clcPositions,
                        extra,
                        notes,
                        deadlineDateTime,
                        deadlineDate,
                        deadlineTime,
                        dateTime,
                        canDoVirtual,
                        hasClc: clcPositions.length > 0,
                        force,
                        useStreamlinedCancellation,
                        realtimeSwapFailure,
                        preselectReversal,
                        prereversalResponsibles,
                        type,
                        centerList: centerList.map(c => ({ ...c, selected: selectedCenters.indexOf(c.id) >= 0 })),
                        logisticsProviderList: selectedLogisticsProviderList,
                        emailFlagList,
                        centerContactPositionList: centerContactPositionList.map(p => ({ ...p, selected: false })),
                        emailSenders,
                        staffList,
                        calendarInvite,
                        signature,
                        currentUserEmail
                    });

                    // this.props.hideLoading();
                })
                .finally(() => {
                    this.props.hideLoading();
                });

            ;
        });
    }

    getCounts = () => {
        let logisticsProviderCount = this.state.logisticsProviderList.filter(x => x.selected).length;
        let centerCount = this.state.centerList.filter(x => x.selected).length;
        let positionCount = this.state.centerContactPositionList.filter(x => x.selected).length;

        return {
            logisticsProviderCount,
            centerCount,
            positionCount
        };
    }

    getTitle = () => {
        let titleMap = {
            'startOffer': 'MATCH OFFER',
            'startXm': 'COMMENCE XM',
            'logisticsCall': 'LOGISTICS CALL',
            'kickOff': 'KICKOFF CALL',
            'joinLogisticsCall': 'LOGISTICS CALL UNDERWAY - PLEASE JOIN',
            'joinKickOff': 'KICKOFF CALL UNDERWAY - PLEASE JOIN',
            'byMissedDeadline': 'Missed Deadline',
            'byCluster': 'CLUSTER',
            'cancelSwap': 'CANCEL SWAP',
            'cancelKitOrder': 'KIT ORDER CANCELLATION',
            '': 'NETWORK'
        };

        return titleMap[this.state.mode];
    }

    getInitialState = (): IState => ({
        currentTab: Tab.Message,
        id: '',
        mode: '',
        sender: 'memberservices@kidneyregistry.org',
        subject: '',
        message: '',
        additionalRecipients: [],
        swapNumber: '',
        swaps: [],
        adpRecipientsFromChain: [],
        coordinators: [],
        swapManager: null,
        positions: [],
        clcPositions: [],
        extra: [],
        notes: [],
        deadlineDateTime: '',
        deadlineDate: '',
        deadlineTime: '',
        dateTime: '',
        canDoVirtual: false,
        hasClc: false,
        force: '',
        useStreamlinedCancellation: 0,
        realtimeSwapFailure: 0,
        preselectReversal: 0,
        prereversalResponsibles: [],
        type: '',
        centerList: [],
        logisticsProviderList: [],
        emailFlagList: [],
        receiveEmailOption: 0,
        centerContactPositionList: [],
        emailSenders: [],
        staffList: [],
        files: [],
        calendarInvite: {
            iCal: false,
            startDate: '',
            startTime: '',
            endDate: '',
            endTime: '',
            requireRsvp: false
        },
        signature: null,
        validation: {
            subject: true,
            message: true,
            centers: true,
            positions: true,
            receiveEmailOption: true,
            calendarInvite: true
        },
        isValid: true,
        dirty: false,
        sentStatus: 0,
        disableSend: false,
        currentUserEmail: '',
        showTestRecipients: false,
        selectedRecipients: []
    });


    handleCheckboxChange = (email) => {
        let updatedRecipients = _.cloneDeep(this.state.selectedRecipients);
        if (updatedRecipients.includes(email)) {
            this.setState({
                selectedRecipients: updatedRecipients.filter(e => e != email)
            });
        } else {
            updatedRecipients.push(email);
            this.setState({
                selectedRecipients: updatedRecipients
            });
        }
    };

    validate = () => {
        let { mode, subject, message, centerList, centerContactPositionList, receiveEmailOption, calendarInvite } = this.state;

        let selectedCenterCount = centerList.filter(x => x.selected).length;
        let selectedPositionCount = centerContactPositionList.filter(x => x.selected).length;

        let st = moment(calendarInvite.startDate + ' ' + calendarInvite.startTime, 'MM/DD/YYYY HH:mm', true);
        let et = moment(calendarInvite.endDate + ' ' + calendarInvite.endTime, 'MM/DD/YYYY HH:mm', true);
        let now = moment();

        let calendarInviteValid = calendarInvite.iCal ? st.isValid() && et.isValid() && st.isBefore(et) && st.isSameOrAfter(now) && et.isSameOrAfter(now) : true;

        let validation: IValidation = {
            subject: subject != '',
            message: mode == '' ? message != '' : true,
            centers: selectedCenterCount > 0,
            positions: receiveEmailOption == 0 ? selectedPositionCount > 0 : true,
            receiveEmailOption: selectedPositionCount == 0 ? receiveEmailOption > 0 : true,
            calendarInvite: calendarInviteValid
        };

        let isValid =
            validation.subject
            && validation.message
            && validation.centers
            && validation.positions
            && validation.receiveEmailOption
            && validation.calendarInvite;

        return { validation, isValid };
    }

    send = (testRecipientList: string[]) => {
        let {
            id, sender, subject, message, positions, clcPositions, extra, deadlineDate, deadlineTime, dateTime, logisticsProviderList, centerList, centerContactPositionList,
            receiveEmailOption, additionalRecipients, selectedRecipients, files, calendarInvite, canDoVirtual, force, useStreamlinedCancellation, realtimeSwapFailure, preselectReversal,
            prereversalResponsibles, type
        } = this.state;

        let request: ISendEmailRequest = {
            mode: this.state.mode,
            clusterId: Utility.isNumber(id) ? parseInt(id) : 0,
            sender,
            subject,
            message,
            hasMeeting: calendarInvite.iCal,
            meetingStartDate: calendarInvite.startDate,
            meetingStartTime: calendarInvite.startTime,
            meetingEndDate: calendarInvite.endDate,
            meetingEndTime: calendarInvite.endTime,
            requireRsvp: calendarInvite.requireRsvp,
            courierList: logisticsProviderList.filter(x => x.selected).map(x => x.id),
            centerList: centerList.filter(x => x.selected).map(x => x.id),
            receiveEmailOption,
            contactPositionList: centerContactPositionList.filter(x => x.selected).map(x => x.id),
            sendToOpo: false,
            additionalRecipients,
            selectedRecipients,
            id: parseInt(id),
            files,
            positions,
            clcPositions,
            extra,
            deadlineDate,
            deadlineTime,
            dateTime,
            canDoVirtual,
            force: force == 'Y',
            useStreamlinedCancellation: useStreamlinedCancellation == 1,
            realtimeSwapFailure: realtimeSwapFailure == 1,
            preselectReversal: preselectReversal == 1,
            prereversalResponsibles,
            type,
            sendImmediately: false,
            testRecipientList,
            sendTestOnly: testRecipientList.length > 0
        };


        if (!this.props.sourceMatchOffer) {
            this.props.showLoading('Sending emails, one moment please...').then(() => {
                this.props.sendEmails(request)
                    .then(response => {
                        if (response.data.success) {
                            if (testRecipientList.length == 0) {
                                toast.success('Emails sent successfully, redirecting back to manage swaps...', {
                                    autoClose: 250,
                                    onClose: () => {
                                        window.location.href = '/manage-swaps/swaps?chain_status=1&status=2';
                                    }
                                });
                            } else {
                                toast.success('Test email sent successfully');
                            }
                        } else {
                            toast.error('Emails not sent successfully, error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        toast.error('Unable to send emails, error:' + error.message)
                    })
                    .finally(() => {
                        this.setState({
                            disableSend: false
                        }, () => {
                            this.props.hideLoading();
                        });
                    })
            });
        }
        else {
            this.props.sendMatchOfferWithComments(this.props.actionType, this.props.matchOfferType, this.props.dateTime, this.props.forceTargetSurgeyDates, request, testRecipientList);
        }
    }

    handleLogisticsProviderChange = (lpId: number) => {
        let logisticsProviderList = _.cloneDeep(this.state.logisticsProviderList).map(lp => {
            if (lp.id == lpId) {
                lp.selected = !lp.selected;
            }

            return lp;
        });

        this.setState({ logisticsProviderList });
    }

    handleCenterTogglesChange = (toggles: CenterToggle[]) => {
        let centerList = _.cloneDeep(this.state.centerList).map(center => {
            center.selected = false;

            toggles.forEach(toggle => {
                if (toggle == CenterToggle.All) {
                    center.selected = true;
                }

                if (toggle == CenterToggle.MemberCenters && center.isNkrParticipant) {
                    center.selected = true;
                }

                if (toggle == CenterToggle.ProspectCenters && center.isNkrParticipant == false) {
                    center.selected = true;
                }

                if (toggle == CenterToggle.DashCenters && center.dashDomain != '') {
                    center.selected = true;
                }

                if (toggle == CenterToggle.DcnCenters && center.isDcnParticipant) {
                    center.selected = true;
                }

                if (toggle == CenterToggle.PartnerCenters && center.isAdpPartner) {
                    center.selected = true;
                }

                if (toggle == CenterToggle.AllInNonPartnerCenters && center.isAdpPartner == false && center.isAllIn) {
                    center.selected = true;
                }

                if (toggle == CenterToggle.MicrositeCenters && center.isMicrositeParticipant == true) {
                    center.selected = true;
                }
            });

            return center;
        });

        this.setState({ centerList });
    }

    handleCenterChange = (centerId: number) => {
        let centerList = _.cloneDeep(this.state.centerList).map(center => {
            if (center.id == centerId) {
                center.selected = !center.selected;
            }

            return center;
        });

        this.setState({ centerList });
    }

    handleReceiveEmailOptionChange = (receiveEmailOption: number) => {
        let centerContactPositionList = _.cloneDeep(this.state.centerContactPositionList).map(position => {
            position.selected = false;
            return position;
        });

        this.setState({
            receiveEmailOption,
            centerContactPositionList
        });
    }

    handlePositionChange = (positionId: number) => {
        let centerContactPositionList = _.cloneDeep(this.state.centerContactPositionList).map(position => {
            if (position.id == positionId) {
                position.selected = !position.selected;
            }

            return position;
        });

        this.setState({
            centerContactPositionList
        });
    }

    handlePositionCheckAll = () => {
        let centerContactPositionList = _.cloneDeep(this.state.centerContactPositionList).map(position => {
            position.selected = !position.selected;
            return position;
        });

        this.setState({ centerContactPositionList });
    }

    handleFilesChange = (files: File[]) => {
        this.setState({
            files
        });
    }

    handleCalendarInviteChange = (iCal: boolean, startDate: string, startTime: string, endDate: string, endTime: string, requireRsvp: boolean) => {
        let calendarInvite = {
            iCal,
            startDate,
            startTime,
            endDate,
            endTime,
            requireRsvp
        };

        this.setState({ calendarInvite });
    }

    handleSenderChange = (sender: string) => {
        let signature = _.cloneDeep(this.state.signature);
        let emailSender = this.state.emailSenders.find(x => x.emailAddress.address == sender);

        if (emailSender != null) {
            let staff = this.state.staffList.find(x => x.email == emailSender.emailAddress.address);
            let companyName = emailSender.emailAddress.address.toLowerCase().indexOf('donorcarenet.org') >= 0 ? 'Donor Care Network' : 'National <span style="color:red">Kidney</span> Registry';

            signature = {
                displayName: emailSender.emailAddress.displayName,
                titles: emailSender.isIndividual ? staff.titles : [],
                companyName,
                html: emailSender.isIndividual && staff?.sendEmail ? staff.emailSignature : null
            }
        }

        this.setState({
            sender,
            signature
        });
    }

    handleSubjectChange = (subject: string) => {
        this.setState({
            subject
        });
    }

    handleMessageChange = (message: string) => {
        this.setState({
            message
        });
    }

    handleSend = () => {
        let { validation, isValid } = this.validate();

        this.setState({
            validation,
            isValid,
            dirty: true,
            sentStatus: 0,
            disableSend: isValid
        }, () => {
            if (isValid) {
                this.send([]);
            }
        });
    }

    handleShowTestRecipientModal = () => {
        this.setState({
            showTestRecipients: true
        });
    }

    handleTestSend = (recipientList: string[]) => {
        this.setState({
            showTestRecipients: false
        }, () => {
            this.send(recipientList);
        });
    }

    handleCancelTestEmail = () => {
        this.setState({
            showTestRecipients: false
        });
    }

    handleTabSelect = (activeKey: any) => {
        this.setState({
            currentTab: parseInt(activeKey)
        });
    }

    render = () => {
        const counts = this.getCounts();
        const sendToTitle = `Send To ${counts.logisticsProviderCount}/${counts.centerCount}${this.state.receiveEmailOption == 0 ? '/' + counts.positionCount : ''}`;
        const attachmentTitle = `Attachments (${this.state.files.length})`;
        const title = this.getTitle();

        return (
            <>
                <div className='container-fluid'>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 30, marginBottom: 20 }}>
                        <div style={{ flexBasis: '100%', fontSize: 28, fontWeight: 500 }}>
                            Send <strong>{title}</strong> Email
                        </div>

                        {this.props.onCloseSidePanel != null &&
                            <div>
                                <Button bsStyle='link' bsSize='sm' onClick={() => this.props.onCloseSidePanel(this.props.actionType)}><Glyphicon glyph='remove' /></Button>
                            </div>
                        }
                    </div>

                    {this.state.sentStatus > 0 && (
                        <Alert bsStyle={this.state.sentStatus == 1 ? 'success' : 'danger'} bsSize='sm'>
                            {this.state.sentStatus == 1 ?
                                <>Emails sent successfully</>
                                :
                                <>Unable to send emails</>
                            }
                        </Alert>
                    )}

                    {this.state.dirty && this.state.isValid == false && (
                        <Validation data={this.state.validation} />
                    )}

                    {this.state.additionalRecipients.length > 0 && (
                        <Alert bsStyle='info' bsSize='sm'>
                            <div style={{ marginBottom: 5 }}>
                                Check all that apply. The below email will be sent to the following additional recipients:
                            </div>
                            <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                                {this.state.additionalRecipients.map(email => (
                                    <li key={email}>
                                        <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'flex-end' }}>
                                            <input
                                                type="checkbox"
                                                style={{
                                                    transform: 'scale(1.2)',
                                                    marginRight: '8px',
                                                    marginBottom: '2px'
                                                }}
                                                checked={this.state.selectedRecipients.includes(email)}
                                                onChange={() => this.handleCheckboxChange(email)}
                                            />
                                            {email}
                                        </label>
                                    </li>
                                ))}
                            </ul>
                        </Alert>

                    )}

                    <div style={{ marginBottom: 5 }}>
                        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                            <NavWrapper bsStyle='tabs' activeKey={this.state.currentTab} onSelect={this.handleTabSelect}>
                                <NavItem eventKey={1}>{sendToTitle}</NavItem>
                                <NavItem eventKey={2}>{attachmentTitle}</NavItem>
                                <NavItem eventKey={3}>Calendar Invite</NavItem>
                                <NavItem eventKey={4}>Message</NavItem>
                            </NavWrapper>
                            <div style={{ paddingLeft: 20, paddingBottom: 3, flexGrow: 1 }}>
                                <Button bsStyle='success' disabled={this.state.disableSend} onClick={this.handleSend}>Send Email</Button>&nbsp;
                                <Button style={{ float: 'right' }} disabled={this.state.disableSend} onClick={this.handleShowTestRecipientModal}>Send Test Email</Button>
                            </div>
                        </div>

                        <div style={{ padding: 10, borderWidth: '1px 1px 1px 1px', borderStyle: 'solid', borderColor: '#ddd', borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>
                            {this.state.currentTab == Tab.Recipients && (
                                <>
                                    <LogisticsProviders
                                        logisticsProviderList={this.state.logisticsProviderList}
                                        onChange={this.handleLogisticsProviderChange}
                                    />

                                    <Centers
                                        centerList={this.state.centerList}
                                        mode={this.state.mode}
                                        onChange={this.handleCenterChange}
                                        onToggleChange={this.handleCenterTogglesChange}
                                    />

                                    <Positions
                                        emailFlagList={this.state.emailFlagList}
                                        receiveEmailOption={this.state.receiveEmailOption}
                                        centerContactPositionList={this.state.centerContactPositionList}
                                        onReceiveEmailOptionChange={this.handleReceiveEmailOptionChange}
                                        onPositionChange={this.handlePositionChange}
                                        onCheckAll={this.handlePositionCheckAll}
                                    />
                                </>
                            )}

                            {this.state.currentTab == Tab.Attachments && (
                                <Attachments
                                    files={this.state.files}
                                    onFilesChange={this.handleFilesChange}
                                />
                            )}

                            {this.state.currentTab == Tab.CalendarInvite && (
                                <CalendarInvite
                                    iCal={this.state.calendarInvite.iCal}
                                    startDate={this.state.calendarInvite.startDate}
                                    startTime={this.state.calendarInvite.startTime}
                                    endDate={this.state.calendarInvite.endDate}
                                    endTime={this.state.calendarInvite.endTime}
                                    requireRsvp={this.state.calendarInvite.requireRsvp}
                                    onChange={this.handleCalendarInviteChange}
                                />
                            )}

                            {this.state.currentTab == Tab.Message && (
                                <Message
                                    sender={this.state.sender}
                                    subject={this.state.subject}
                                    message={this.state.message}
                                    swapNumber={this.state.swapNumber}
                                    force={this.props.forceTargetSurgeyDates}
                                    extra={this.state.extra}
                                    notes={this.state.notes}
                                    mode={this.state.mode}
                                    swaps={this.state.swaps}
                                    adpRecipientsFromChain={this.state.adpRecipientsFromChain}
                                    coordinators={this.state.coordinators}
                                    swapManager={this.state.swapManager}
                                    deadlineDate={this.state.deadlineDate}
                                    deadlineTime={this.state.deadlineTime}
                                    dateTime={this.state.dateTime}
                                    canDoVirtual={this.state.canDoVirtual}
                                    signature={this.state.signature}
                                    senders={this.state.emailSenders}
                                    sidebar={this.props.onCloseSidePanel != null}
                                    onSenderChange={this.handleSenderChange}
                                    onSubjectChange={this.handleSubjectChange}
                                    onMessageChange={this.handleMessageChange}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <TestRecipientsModal
                    show={this.state.showTestRecipients}
                    currentUserEmail={this.state.currentUserEmail}
                    onSend={this.handleTestSend}
                    onCancel={this.handleCancelTestEmail} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getLookupData: () => {
            return dispatch(NetworkEmailActionCreators.getLookupData());
        },
        getDefaultContent: (mode, id, positions, clcPositions, date, deadline, force, type, realtimeSwapFailure, vendor) => {
            return dispatch(NetworkEmailActionCreators.getDefaultContent(mode, id, positions, clcPositions, date, deadline, force, type, realtimeSwapFailure, vendor));
        },
        sendEmails: (request) => {
            return dispatch(NetworkEmailActionCreators.sendEmails(request));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(EmailContainer);
